import { UrlConstants } from "../url.constants";
export class ApiCommunicationConstants {
    static URL = UrlConstants.API_V2 + "Communication";
    static FUNCTION_GET_COMMUNICATION_BY_JOBID = "GetAFLAPortalCommunicationsForApplicantByJobID";
    static FUNCTION_GENERATE_EMAIL = "GenerateEmail";
}
